import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { verifyUserOtp, sendUserOtp } from "../../sdk/auth/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";
import { createPermissionApi } from "../../hooks/permissionUtils";
import { getFirstAllowedRoute } from "../../helpers/getFirstAllowedRoute";
import { menuItems } from "../../config/menuConfig";

const Verification = () => {
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(30);
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prevSeconds) => prevSeconds - 1);
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [seconds]);

  const handleRestartTimer = async () => {
    await sendUserOtp(auth?.user?.id);
    setSeconds(30);
  };

  const handleLogin = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      const result = await verifyUserOtp(
        otp,
        auth?.user?.id,
        auth?.user?.email,
        auth?.user?.phone
      );

      if (result?.message === "Success") {
        const user = result?.data?.user;
        const tokens = result?.data?.tokens;
        let roles = [1999, 2000, 2001];
        const role = result?.data;

        if (tokens) {
          setAuth({ user, roles, role, tokens });
        }
        if (result?.data?.user?.logintimes) {
          // navigate("/dashboard", { replace: true });
          const permissionApi = createPermissionApi(
            role?.userPermissions || []
          );
          const redirectTo = getFirstAllowedRoute(menuItems, permissionApi);
          navigate(redirectTo, { replace: true });
          toast?.success("Welcome to Anansi");
        } else {
          navigate("/new-password", { replace: true });
        }

        setIsLoading(false);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="w-[100%] h-[calc(100vh)] bg-[#FFF] relative">
        <div className="flex items-center h-full relative">
          <div className="w-[90%] h-[95%] flex items-center px-5 gap-[100px]">
            <div className="w-[652px] bg-[#F0FFFE] relative h-[98%] flex flex-col items-center justify-center rounded-[30px]">
              <img src="/logo.png" alt="Logo" className="z-50" />

              <img
                src="/ground.png"
                alt="background"
                className="w-[80%] z-50 h-[50%]"
              />

              <div className="mt-16">
                <p className="text-[#074073] text-[32px] font-[500]">
                  Making Your Work Easier To <br />
                  Serve Our Members Better.
                </p>

                <svg
                  width="472"
                  height="46"
                  viewBox="0 0 482 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 42C77.6804 19.2828 221.099 -3.53939 478 6.38599"
                    stroke="#074073"
                    stroke-width="8"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <div className="w-[50%] h-[624px] flex items-center">
              <div className="w-[100%] z-50 bg-white h-[100%] flex px-[20px] flex-col justify-center">
                <p className="text-[20px] text-[#074073] font-[500] mb-[30px]">
                  Additional security verification
                </p>
                <p className="text-[14px] text-[#060606] font-[300] mb-[10px]">
                  For added security we need to further verify your account we
                  just <br /> sent an SMS to the phone number below:
                </p>
                <div className="h-[81px] w-[464px] bg-[#F0FFFE] w-full flex items-center gap-[20px]">
                  <img src="/otp.png" alt="otp" class="w-[60px] h-auto" />
                  <p className="text-[15px] text-[#000]">
                    {auth?.user?.phone
                      ? `${auth?.user?.phone?.slice(
                          0,
                          7
                        )} ****${auth?.user?.phone?.slice(-2)}`
                      : ""}
                  </p>
                </div>
                <p className="text-[14px] text-[#060606] font-[300] ">
                  Please enter the verification OTP code provided in the phone
                  number to log in
                </p>
                <form onSubmit={handleLogin}>
                  <div className="my-[10px] flex items-center w-full">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      onPaste={true}
                      shouldAutoFocus
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{ width: "45px", height: "43px" }}
                        />
                      )}
                      renderSeparator={<span className="mx-4" />}
                      inputStyle="bg-white text-center text-[24px] rounded-[5px] text-[#000] border-[1px] border-[#000]"
                    />
                  </div>
                  <div className="mt-[30px] w-[80%] flex justify-between items-center">
                    <p className="text-[#074073] text-[14px]">
                      Didn’t receive a code?
                    </p>
                    {seconds === 0 ? (
                      <p
                        className="cursor-pointer text-[#074073]"
                        onClick={handleRestartTimer}
                      >
                        Resend
                      </p>
                    ) : (
                      <p className="text-[#074073] text-[14px]">
                        Resend in
                        <span className="text-[#074073] text-[14px] ml-2">
                          00:{seconds}
                        </span>
                      </p>
                    )}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="bg-[#074073] mt-[30px] flex items-center justify-center gap-[10px] text-white rounded-[5px] w-[464px] h-[43px]"
                    >
                      {isLoading && (
                        <svg
                          aria-hidden="true"
                          className="w-[20px] h-[20px] text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      )}
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
